import React, { useState } from 'react';
import './EventsWidget.css';

const EventsWidget = () => {
  // State to manage which modal content is visible (null means closed)
  const [activeModal, setActiveModal] = useState(null);
  
  // State to manage the current image index for the placements carousel
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Array of your placement images
  const placementImages = [
    "/EventWidget/Asset6.webp",
    "/EventWidget/Asset4.webp",
    "/EventWidget/Asset3.webp",
    "/EventWidget/Asset2.webp",
    "/EventWidget/Asset5.webp",
  ];

  const openModal = (type) => {
    setActiveModal(type);
    setCurrentImageIndex(0); // Reset to the first image whenever opened
  };
  
  const closeModal = () => {
    setActiveModal(null);
  };

  // Carousel Navigation Functions
  const nextImage = (e) => {
    e.stopPropagation(); // Prevents clicks from closing the modal
    setCurrentImageIndex((prevIndex) => 
      prevIndex === placementImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = (e) => {
    e.stopPropagation(); // Prevents clicks from closing the modal
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? placementImages.length - 1 : prevIndex - 1
    );
  };

  return (
    <section className="stu-section">
      {/* Decorative background elements */}
      <div className="stu-bg-dots"></div>
      <div className="stu-bg-circle"></div>

      <div className="stu-container">
        {/* Header Section */}
        <div className="stu-header-wrapper">
          <div className="stu-label-container">
            <span className="stu-line"></span>
            <span className="stu-label">EVENTS</span>
            <span className="stu-line"></span>
          </div>
          <h2 className="stu-title">Campus Updates</h2>
        </div>

        {/* Content Section */}
        <div className="stu-cards-wrapper">
          {/* Upcoming Events Card */}
          <div className="stu-card">
            <div className="stu-card-header">
              <div className="stu-icon-wrapper">
                <svg className="stu-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
              </div>
              <div className="stu-card-title-wrapper">
                <h3 className="stu-card-title">Upcoming Events</h3>
                <p className="stu-card-subtitle">Don't miss what's coming next at TIMSCDR.</p>
              </div>
            </div>
            
            <div className="stu-list">
              {/* Added onClick and stu-clickable-item class to FDP */}
              <div className="stu-list-item stu-clickable-item" onClick={() => openModal('fdp')}>
                <div className="stu-item-icon"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg></div>
                <span className="stu-item-text">Faculty Development Program (FDP) – 2027</span>
                <span className="stu-item-arrow">&rarr;</span>
              </div>
            </div>
          </div>

          {/* Featured Events Card */}
          <div className="stu-card">
            <div className="stu-card-header">
              <div className="stu-icon-wrapper">
                <svg className="stu-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" /></svg>
              </div>
              <div className="stu-card-title-wrapper">
                <h3 className="stu-card-title">Featured Events</h3>
                <p className="stu-card-subtitle">Highlights and moments from our recent events.</p>
              </div>
            </div>
            
            <div className="stu-list">
              {/* Clickable list item for Placements */}
              <div className="stu-list-item stu-clickable-item" onClick={() => openModal('placements')}>
                <div className="stu-item-icon"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg></div>
                <span className="stu-item-text">Placement Highlights</span>
                <span className="stu-item-arrow">&rarr;</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      {activeModal && (
        <div className="stu-modal-overlay" onClick={closeModal}>
          <div className="stu-modal-content" onClick={(e) => e.stopPropagation()}>
            
            {/* FDP PDF Viewer Modal */}
            {activeModal === 'fdp' && (
              <div style={{ backgroundColor: 'var(--tm-bg)', width: '100%', height: '85vh', borderRadius: '12px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="stu-modal-header" style={{ padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid var(--tm-border)' }}>
                  <h3 className="stu-modal-title" style={{ margin: 0, color: 'var(--tm-text)', fontSize: '1.25rem' }}>FDP Brochure</h3>
                  <button className="stu-modal-close" onClick={closeModal} style={{ background: 'transparent', border: 'none', fontSize: '2rem', cursor: 'pointer', color: 'var(--tm-text-muted)' }}>&times;</button>
                </div>
                {/* Notice the %20 used to encode the spaces in the filename so the browser can read it */}
                <iframe 
                  src="/EventWidget/FDP%20Brochure%202027%20(18-23%20Jan)%203Fold%20Atal.pdf" 
                  title="FDP Brochure" 
                  style={{ flexGrow: 1, width: '100%', border: 'none' }}
                />
              </div>
            )}

            {/* Calendar Modal */}
            {activeModal === 'calendar' && (
              <div style={{ backgroundColor: 'var(--tm-bg)', width: '100%', borderRadius: '12px', overflow: 'hidden' }}>
                <div className="stu-modal-header" style={{ padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid var(--tm-border)' }}>
                  <h3 className="stu-modal-title" style={{ margin: 0, color: 'var(--tm-text)', fontSize: '1.25rem' }}>2026 Events Calendar</h3>
                  <button className="stu-modal-close" onClick={closeModal} style={{ background: 'transparent', border: 'none', fontSize: '2rem', cursor: 'pointer', color: 'var(--tm-text-muted)' }}>&times;</button>
                </div>
                <div className="stu-modal-body">
                  <img 
                    src="https://placehold.co/800x1200/5865f2/ffffff?text=Events+Calendar+2026" 
                    alt="Events Calendar" 
                    className="stu-modal-file" 
                  />
                </div>
              </div>
            )}

            {/* Placements Carousel Modal */}
            {activeModal === 'placements' && (
              <>
                <div className="stu-carousel-container">
                  
                  {/* Floating Close Button */}
                  <button className="stu-carousel-close-btn" onClick={closeModal}>
                    &times;
                  </button>

                  {/* Left Arrow */}
                  <button className="stu-carousel-arrow stu-arrow-left" onClick={prevImage}>
                    &#10094;
                  </button>

                  {/* Active Image */}
                  <img 
                    src={placementImages[currentImageIndex]} 
                    alt={`Placement ${currentImageIndex + 1}`} 
                    className="stu-carousel-image" 
                  />

                  {/* Right Arrow */}
                  <button className="stu-carousel-arrow stu-arrow-right" onClick={nextImage}>
                    &#10095;
                  </button>

                  {/* Dots Indicator */}
                  <div className="stu-carousel-dots">
                    {placementImages.map((_, idx) => (
                      <span 
                        key={idx} 
                        className={`stu-carousel-dot ${idx === currentImageIndex ? 'active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex(idx);
                        }}
                      ></span>
                    ))}
                  </div>
                </div>
              </>
            )}
            
          </div>
        </div>
      )}
    </section>
  );
};

export default EventsWidget;